import React from 'react';
import {
    MDBModal, MDBModalBody, MDBModalHeader,
    MDBModalFooter, MDBDataTable, MDBBadge, MDBBtn,
    MDBCard, MDBCardBody, MDBCol, MDBFooter,
    MDBRow,
    MDBPageItem, MDBPagination, MDBPageNav,
} from 'mdbreact';
// import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
// import profile_pic from '../../Assets/blank-profile-picture.png';
// import MenuItem from '@material-ui/core/MenuItem';
import comment from '../../Assets/comment_icon.svg';
import axios from '../../authAxios'
import styles from './TrackApplication.module.css'
import { Redirect } from 'react-router-dom';
import moment from 'moment';
import { DatePicker, Space } from 'antd';
import DateTimePicker from 'react-datetime-picker';
const { RangePicker } = DatePicker;

export class TrackApplication extends React.Component {
    constructor(props) {
        super(props);
        var start_dt = new Date()
        start_dt.setDate(new Date().getDate() - 15)

        var end_dt = new Date()
        end_dt.setDate(new Date().getDate())

        this.state = {
            activeItem: "1",
            applicationDataObj: [],
            gray_status_color: '#AAAAAA',
            red_status_color: '#FB4A36',
            orange_status_color: '#FFAA00',
            green_status_color: '#26AF48',
            not_approved_status_color: '#dc3545',
            applicantData: [],
            selectedApplicantData: [],
            selectedApplicationData: [],
            embassySubmitDate: '',
            activity: [],
            showBankTransferModel: false,
            reciept_number: '',
            isRecieptError: false,
            recieptErrormsg: '',
            bank_trnsaction_date: '',
            booking_info_for_payment: '',
            isDateError: false,
            isUploadDoc: false,
            isPaymentDetails: false,
            isReviewApplication: false,
            showActivityModal: false,
            paginatedItems: [],
            prePage: "",
            nextPage: "",
            pageNo: 1,
            totalPages: "",
            ShowArchiveModal: false,
            selected_archive_application_id: '',
            startDate: start_dt,
            endDate: end_dt
        }
        this.myApplication_BookingStatus = this.myApplication_BookingStatus.bind(this)
        this.showActivity = this.showActivity.bind(this)
        this.redirectToUploadDoc = this.redirectToUploadDoc.bind(this);
        this.showApplicantDetails = this.showApplicantDetails.bind(this)
        this.applicationActivity = this.applicationActivity.bind(this)
        this.hideBankTransferModel = this.hideBankTransferModel.bind(this)
        this.handleBankConfirmClick = this.handleBankConfirmClick.bind(this)
        this.show_Bank_Transaction_Model = this.show_Bank_Transaction_Model.bind(this)
        this.previousPage = this.previousPage.bind(this)
        this.nextPage = this.nextPage.bind(this)
        this.hideArchiveModal = this.hideArchiveModal.bind(this)
        this.handleArchiveConfirmClick = this.handleArchiveConfirmClick.bind(this)
        this.ShowArchivePopup = this.ShowArchivePopup.bind(this)
        this.handleDateRangeChange = this.handleDateRangeChange.bind(this)
    }
    componentDidMount() {
        this.api_getApplicationList(this.state.startDate, this.state.endDate)
    }

    handleDateRangeChange = (momentDate) => {
        let start_dt = momentDate[0]._d
        let end_dt = momentDate[1]._d
        this.setState({ startDate: momentDate[0]._d, endDate: momentDate[1]._d })
        this.api_getApplicationList(start_dt, end_dt)
    }

    pagination(items, currentPage, itemsPerPage) {

        let current_page = currentPage || 1;
        let items_perPage = itemsPerPage || 2;
        let offset = (current_page - 1) * items_perPage

        let paginated_items = items.slice(offset).slice(0, items_perPage)
        let total_pages = Math.ceil(items.length / items_perPage)


        this.setState({
            paginatedItems: paginated_items
            , nextPage: ((total_pages > current_page) ? current_page + 1 : total_pages)
            , prePage: ((current_page - 1) ? current_page - 1 : 1),
            totalPages: total_pages
        })


        return {
            page: current_page,
            items_page: items_perPage,
            pre_page: (current_page - 1) ? current_page - 1 : null,
            next_page: (total_pages > current_page) ? current_page + 1 : null,
            total: items.length,
            totalPages: total_pages,
            data: paginated_items
        }


    }


    previousPage() {
        this.pagination((this.state.applicationDataObj), (this.state.prePage), 10)
        this.setState({ pageNo: this.state.prePage })
    }

    nextPage() {
        this.pagination((this.state.applicationDataObj), (this.state.nextPage), 10)
        this.setState({ pageNo: this.state.nextPage })
    }
    toggle = tab => e => {
        if (this.state.activeItem !== tab) {
            this.setState({
                activeItem: tab
            });
        }
    };
    ShowArchivePopup = (applicationId) => {
        this.setState({
            selected_archive_application_id: applicationId,
            ShowArchiveModal: !this.state.ShowArchiveModal,
        })
    }
    hideArchiveModal = () => {
        this.setState({ ShowArchiveModal: !this.state.ShowArchiveModal })
    }
    handleArchiveConfirmClick = () => {
        this.setState({ ShowArchiveModal: false })
        this.api_deleteApplication(this.state.selected_archive_application_id)
    }

    capitalize = (s) => {
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)
    }

    showTotalApplicantCount = (applicantData) => {
        // console.log(applicantData)
        // console.log(applicantData)
        var applicants = [],
            applicants = applicantData
        return <span>{applicants.length}</span>
    }

    // new method to show booking status
    myApplication_BookingStatus = (bookingStatus, applicationObj) => {
        if (bookingStatus === "upload_documents") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${this.state.gray_status_color}`, color: 'white'
            }}>Document Required</MDBBadge>
        } else if (bookingStatus === "review_visa_form") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${this.state.gray_status_color}`, color: 'white'
            }}>Information Required</MDBBadge>
        }
        // else if (bookingStatus === "on_hold") {
        //     return <MDBBadge className=" p-2 shadow-none" color="none" style={{
        //         textTransform: 'none',
        //         background: `${this.state.submitted_status_color}`, color: 'white'
        //     }}>Application Submitted</MDBBadge>
        // }
        else if (bookingStatus === "payment") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${this.state.gray_status_color}`, color: 'white'
            }}>Payment Pending</MDBBadge>
        } else if (bookingStatus === "payment_failed") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${this.state.red_status_color}`, color: 'white'
            }}>Payment Failed</MDBBadge>
        }//else if (bookingStatus === "booking_submitted") {
        //     return <MDBBadge className=" p-2 shadow-none" color="none" style={{
        //         textTransform: 'none',
        //         background: `${this.state.submitted_status_color}`, color: 'white',
        //     }}>Application Submitted</MDBBadge>
        // }
        else if (bookingStatus === "pending_finance_approval") {
            var payment_mode = applicationObj.payment_mode
            var payment_status = applicationObj.payment_status
            // console.log(payment_mode)
            if (payment_mode === 'pay_at_center') {
                return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                    textTransform: 'none',
                    background: `${this.state.orange_status_color}`, color: 'white'
                }}>Payment Pending</MDBBadge>
            } else if (payment_mode === 'bank_transfer' && payment_status === 'PAID') {
                return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                    textTransform: 'none',
                    background: `${this.state.orange_status_color}`, color: 'white'
                }}>Payment Confirmation Pending</MDBBadge>
            } else { //online payment paid
                return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                    textTransform: 'none',
                    background: `${this.state.orange_status_color}`, color: 'white'
                }}>Application Under Review</MDBBadge>
            }

        }
        else if (bookingStatus === "pending_bank_tranfer") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${this.state.orange_status_color}`, color: 'white'
            }}>Payment Pending</MDBBadge>
        } else if (bookingStatus === "visa_in_process") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${this.state.green_status_color}`, color: 'white'
            }}>Application In Progress</MDBBadge>
        } else if (bookingStatus === "in_queue") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${this.state.orange_status_color}`, color: 'white'
            }}>In Queue</MDBBadge>
        } else if (bookingStatus === "application_posted") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${this.state.orange_status_color}`, color: 'white'
            }}>Application Posted</MDBBadge>
        } else if (bookingStatus === "additional_documents_required") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${this.state.orange_status_color}`, color: 'white'
            }}>Additional Documents Required</MDBBadge>
        } else if (bookingStatus === "application_approved") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${this.state.green_status_color}`, color: 'white'
            }}>Approved</MDBBadge>
        }
        else if (bookingStatus === "application_rejected") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${this.state.not_approved_status_color}`, color: 'white'
            }}>Not Approved</MDBBadge>
        } else if (bookingStatus === "decision_taken") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${this.state.green_status_color}`, color: 'white'
            }}>Decision Taken</MDBBadge>
        } else if (bookingStatus === "application_submitted") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${this.state.green_status_color}`, color: 'white'
            }}>Application In Progress</MDBBadge>
        } else {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${this.state.orange_status_color}`, color: 'white',
            }}>Application Under Review</MDBBadge>
        }
    }

    // new method to show booking status
    myApplication_Actions = (bookingStatus, applicationId, travellingToIdentity, i, baseCurrencySymbol) => {
        if (bookingStatus === "upload_documents") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.redirectToUploadDoc(applicationId)} >Upload Document </a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)}>Activity</a>]
        } else if (bookingStatus === "review_visa_form") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.redirectToReviewApplication(applicationId, travellingToIdentity)}>Review </a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else if (bookingStatus === "payment") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => { this.redirectToPaymentDetails(baseCurrencySymbol, applicationId) }}>Make Payment </a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else if (bookingStatus === "payment_failed") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => { this.redirectToPaymentDetails(baseCurrencySymbol, applicationId) }}>Retry </a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else if (bookingStatus === "pending_bank_tranfer") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.show_Bank_Transaction_Model(i)}>Enter Transaction Number</a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else if (bookingStatus === "decision_taken" || bookingStatus === "application_approved" || bookingStatus === "application_rejected") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} data-toggle="modal" data-target="#DecisionModal" onClick={() => this.showApplicantDetails(i)}>Visa Details</a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else if (bookingStatus === "application_submitted" || bookingStatus === "visa_in_process" || bookingStatus === "in_queue" || bookingStatus === "application_posted" || bookingStatus === "additional_documents_required") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} data-toggle="modal" data-target="#DecisionModal" onClick={() => this.showApplicantDetails(i)}>Details</a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        }
    }

    // previously used method to show booking status
    showActionButons = (bookingStatus, applicationId, travellingToIdentity, i, baseCurrencySymbol) => {
        console.log(i)
        if (bookingStatus === "upload_documents") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.redirectToUploadDoc(applicationId)} >Upload Document </a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)}>Activity</a>]
        } else if (bookingStatus === "draft") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} >Resume </a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else if ((bookingStatus === "payment_pending") || (bookingStatus === "payment_flagged")) {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} >Contact Support </a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        }//payment_failed
        else if (bookingStatus === "payment_failed") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} >Retry </a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        }
        else if (bookingStatus === "payment_confirmation") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} >Confirm Payment </a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else if (bookingStatus === "ready_for_review") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} >Review </a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} >Download Documents </a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else if (bookingStatus === "additional_information") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} >Add information </a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else if (bookingStatus === "payment") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => { this.redirectToPaymentDetails(baseCurrencySymbol, applicationId) }}>Make Payment </a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else if (bookingStatus === "payment_confirmed") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} >Payment Confirmed </a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else if (bookingStatus === "ready_for_submission") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else if (bookingStatus === "booking_submitted") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else if (bookingStatus === "rejected") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else if (bookingStatus === "approved") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} >Download Visa </a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else if (bookingStatus === "review_visa_form") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.redirectToReviewApplication(applicationId, travellingToIdentity)}>Review </a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else if (bookingStatus === "scheduled") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} >Reschedule </a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} >Submit Now </a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else if (bookingStatus === "expired") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} >Update Date </a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else if (bookingStatus === "decision_taken") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} data-toggle="modal" data-target="#DecisionModal" onClick={() => this.showApplicantDetails(i)}>Visa Details</a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else if (bookingStatus === "visa_in_process") {
            return [
                <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else if (bookingStatus === "pending_bank_tranfer") {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.show_Bank_Transaction_Model(i)}>Enter Transaction Number</a>,
            <span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        } else if (bookingStatus === "pending_finance_approval") {
            return [
                <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]

        }
        else {
            return [<a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.applicationActivity(applicationId)} >Activity</a>]
        }
    }
    showDeleteAction = (applicationObj) => {
        var applicationId = applicationObj._id
        if (applicationObj.application_state === "upload_documents" || applicationObj.application_state === "review_visa_form") {
            return [<span> | </span>,
            <a href="#/" style={{ color: 'blue', textDecoration: 'underline' }} onClick={() => this.ShowArchivePopup(applicationId)}>Delete</a>]
        } else {
            return ""
        }
    }

    showVisaStatus = (bookingStatus) => {

        if (bookingStatus === "pending") {
            return <MDBBadge className="p-2 shadow-none" color="none" style={{
                // textTransform: 'none',
                textIndent: "0px",
                background: `${this.state.orange_status_color}`, color: 'white'
            }}>Decision Pending</MDBBadge>
        } else if (bookingStatus === "decision_taken") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                textIndent: "0px",
                background: `${this.state.green_status_color}`, color: 'white'
            }}>Decision Taken</MDBBadge>
        } else if (bookingStatus === "visa_in_process") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${this.state.green_status_color}`, color: 'white'
            }}>Application In Progress</MDBBadge>
        } else if (bookingStatus === "in_queue") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${this.state.orange_status_color}`, color: 'white'
            }}>In Queue</MDBBadge>
        } else if (bookingStatus === "application_posted") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${this.state.orange_status_color}`, color: 'white'
            }}>Application Posted</MDBBadge>
        } else if (bookingStatus === "additional_documents_required") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${this.state.orange_status_color}`, color: 'white'
            }}>Additional Documents Required</MDBBadge>
        } else if (bookingStatus === "application_approved") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${this.state.green_status_color}`, color: 'white'
            }}>Approved</MDBBadge>
        } else if (bookingStatus === "application_rejected") {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                background: `${this.state.not_approved_status_color}`, color: 'white'
            }}>Not Approved</MDBBadge>
        } else if (bookingStatus === "-") {
            return <> - </>
        } else {
            return <MDBBadge className=" p-2 shadow-none" color="none" style={{
                textTransform: 'none',
                textIndent: "0px",
                background: `${this.state.orange_status_color}`, color: 'white'
            }}>{bookingStatus}</MDBBadge>
        }
    }
    showVisaActionButton = (bookingStatus, applicantId, applicationId, i) => {
        if (bookingStatus === "pending") {
            return ''
        } else if (bookingStatus === "decision_taken" || bookingStatus === "application_approved") {
            return [
                <a style={{ color: 'blue', textDecoration: 'underline' }} href="#/"
                    onClick={() => this.handleDownloadClick(i.evisa.visa_file_name, applicantId, applicationId)} >Download Visa</a>]
        } else {
            return ''
        }
    }
    handleDownloadClick(docName, applicantID, applicationID) {
        axios
            .get('/visa-admin/downloadEVisa', {
                params: {
                    application_id: applicationID,
                    applicant_id: applicantID,
                    document_name: docName
                },
            })
            .then((response) => {
                //   console.log(response);
                window.open(response.data.dataobj.document_url)
            }).catch((err) => {
                console.log(err);
            })
    }

    showActivity = (applicationId) => {
        // alert(applicationId)
        // console.log(applicationId)
    }
    show_Bank_Transaction_Model = (bookingInfo) => {
        // console.log("show_Bank_Transaction_Model")
        //  console.log(bookingInfo)
        this.setState({
            booking_info_for_payment: bookingInfo,
            showBankTransferModel: !this.state.showBankTransferModel
        })
        // console.log("this.state.booking_info_for_payment")
        // console.log(this.state.booking_info_for_payment)
    }
    hideBankTransferModel = () => {
        this.setState({ showBankTransferModel: !this.state.showBankTransferModel })
    }
    hideActivityModal = () => {
        this.setState({
            showActivityModal: !this.state.showActivityModal
        })
    }
    handleRecieptChange = e => {
        this.setState({
            recieptErrormsg: '',
            isRecieptError: false,
            reciept_number: e.target.value
        })
    }
    handleBankDate = (date) => {
        // console.log(e.target.value)
        if (date === null) {
            // console.log("on close null")
            this.setState({ bank_trnsaction_date: "" })
        } else {
            this.setState({
                bank_trnsaction_date: date,
                isDateError: false
            })
            // console.log("on close ok")
            // console.log(this.state.bank_trnsaction_date)
            // let monthNames =["Jan","Feb","Mar","Apr",
            //                 "May","Jun","Jul","Aug",
            //                 "Sep", "Oct","Nov","Dec"];    

            // var dt = new Date(date);
            // var datestr = dt.getDate()+'-'+monthNames[(dt.getMonth())]+'-'+dt.getFullYear()
            // console.log(date)
            // console.log(datestr)
            //localStorage.setItem('journey_start_date', datestr);
            this.setState({ bank_trnsaction_date: date })
            // console.log("Arrival Date =>" ,  this.state.journey_start_date);
            //             this.arrival = new Date(this.state.journey_start_date).getTime()
        }

    }
    getReadableDate(givenDate) {
        let monthNames = ["Jan", "Feb", "Mar", "Apr",
            "May", "Jun", "Jul", "Aug",
            "Sep", "Oct", "Nov", "Dec"];
        var dt = new Date(givenDate)
        var dateStr = dt.getDate() + "-" + monthNames[(dt.getMonth())] + "-" + dt.getFullYear() + " "
        return dateStr
    }
    handleBankConfirmClick = () => {

        if (this.state.reciept_number === '') {
            this.setState({
                recieptErrormsg: 'Please enter transaction id',
                isRecieptError: true
            })
            return
        }
        if (this.state.bank_trnsaction_date === '') {
            this.setState({
                isDateError: true
            })
            return
        }
        // console.log("this.state.bank_trnsaction_date")
        // console.log(this.state.bank_trnsaction_date)
        this.api_postConfirmPayment()

    }
    api_postConfirmPayment = () => {
        var application = this.state.booking_info_for_payment
        var date = this.state.bank_trnsaction_date
        date = new Date(date);
        var dd = (date.getDate() < 10 ? '0' : '') + date.getDate()
        let monthNames = ["Jan", "Feb", "Mar", "Apr",
            "May", "Jun", "Jul", "Aug",
            "Sep", "Oct", "Nov", "Dec"]
        // var MM = ((date.getMonth() + 1) < 10 ? '0' : '') + (date.getMonth() + 1);
        var MM = monthNames[date.getMonth()]
        var converted_date = dd + "-" + MM + "-" + date.getFullYear() //+ "-" + (datee.getMonth()+1) + "-" + datee.getDate()
         
        console.log("converted_date")
        console.log(converted_date)
        
        axios
            .post('/visa-payment/updateBankTransferDetails', {
                "application_id": application.application_obj._id,
                "user_id": localStorage.getItem("user_id"),
                "bank_transaction_number": this.state.reciept_number,
                "transaction_date": converted_date //this.state.bank_trnsaction_date
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then((response) => {
                // console.log(response);
                if (response.data.data === "error") {
                    alert(response.msg)

                } else {
                    this.api_getApplicationList(this.state.startDate, this.state.endDate)
                }
                this.setState({
                    showBankTransferModel: false
                })

            }).catch((error) => {
                console.log(error);
            });
    };

    applicationActivity = (applicationId) => {


        axios.get('visa/getApplicationActivities', {
            params: {
                application_id: applicationId
            },
        })
            .then((response) => {
                // console.log("Response===>" , response.data.dataobj);
                this.setState({ activity: response.data.dataobj, showActivityModal: true })
            }).catch((error) => {
                console.log(error);
            })


        this.showActivity(applicationId)
    }
    api_deleteApplication(application_id) {
        axios
            .post('/visa/deleteApplication', {
                "application_id": application_id,
                "user_id": localStorage.getItem("user_id"),
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then((resp) => {
                console.log(resp)
                if (resp.data.data === "error") {
                    alert(resp.data.msg)
                } else {
                    this.api_getApplicationList(this.state.startDate, this.state.endDate)

                }


            })
    }

    showApplicantDetails = (i) => {
        // console.log("i====")

        // set embassy submit date from applicant's array (first index)  
        if (i.applicants_data.length > 0) {
            // console.log(i.applicants_data[0].application_submitted_date)
            let monthNames = ["Jan", "Feb", "Mar", "Apr",
                "May", "Jun", "Jul", "Aug",
                "Sep", "Oct", "Nov", "Dec"];
            var dt = new Date(i.applicants_data[0].application_submitted_date)
            var dateStr = dt.getDate() + "-" + monthNames[(dt.getMonth())] + "-" + dt.getFullYear()
            this.setState({ embassySubmitDate: dateStr })
        }
        // set selected application and applicant data to show decision taken model
        this.setState({
            selectedApplicantData: i.applicants_data,
            selectedApplicationData: i.application_obj
        })
    }

    redirectToUploadDoc = (applicationId) => {
        // console.log(applicationId)
        localStorage.setItem("application_id", applicationId)
        this.setState({ isUploadDoc: true })
    }

    redirectToReviewApplication = (applicationId, travellingToIdentity) => {
        localStorage.setItem("application_id", applicationId)
        localStorage.setItem('travelling_to_identity', travellingToIdentity)
        this.setState({ isReviewApplication: true })
    }

    redirectToPaymentDetails = (baseCurrencySymbol, applicationId) => {
        localStorage.setItem("application_id", applicationId)
        localStorage.setItem('base_currency_symbol', baseCurrencySymbol)
        this.setState({ isPaymentDetails: true })
    }
    getDurationType(durationType) {
        var visa_duration_type = "days"
        if (durationType != null || durationType != undefined) {
            visa_duration_type = durationType
        }
        visa_duration_type = this.capitalize(visa_duration_type)
        return visa_duration_type
    }

    api_getApplicationList = (start_date, end_date) => {
        // console.log(this.state.user_id)
        axios.get('visa/getUserApplication', {
            params: {
                user_id: localStorage.getItem("user_id"), //'5fcf1abf499f7135dc9ce406'//
                start_date: start_date,
                end_date: end_date
            },
        })
            .then((response) => {
                // let data = response.data;
                // console.log("get userData response===")
                // console.log(data)
                // console.log("===")
                if (response.data.data === "error") {


                } else {
                    console.log("success")
                    // console.log(response.data.dataobj)
                    this.setState({
                        applicationDataObj: response.data.dataobj
                    })
                    this.pagination(response.data.dataobj, this.state.pageNo, 10)

                }

            }).catch((error) => {
                console.log(error);
            });
    };
    showNoDataCard() {
        return <>
            <MDBRow>
                <MDBCol size="12" md="12" sm="12">
                    <br />
                                        No records found.
                                        <br /><br />
                    {/* <MDBBtn id="continueBtn" style={{ color: 'white', backgroundColor: localStorage.getItem("brand_color"), width: '100px', fontSize: 'calc(8px + .5rem)', textTransform: 'none' }} color="none" onClick={this.handleRetryBtnClick}>Apply</MDBBtn> */}


                </MDBCol>
            </MDBRow>
        </>
    }

    render() {


        const stepsIcon = () => {
            return <img alt='' src={comment} />
        }
        if (this.state.isUploadDoc) {
            return <Redirect to="/new-visa/organize" />
        }
        if (this.state.isPaymentDetails) {
            return <Redirect to="/payment-details" />
        }
        if (this.state.isReviewApplication) {
            return <Redirect to="/new-visa/review" />
        }
        const showTable = (dataArray) => {

            return <>
                <MDBDataTable responsive style={{ tfootDisplay: "none" }}
                    sortable={false}
                    searching={false}
                    displayEntries={false}
                    striped={false}
                    bordered={false}
                    hover
                    data={dataArray}
                    tag='application'
                    disableRetreatAfterSorting={true}
                />
            </>
        }
        const showApplicantTable = (dataArray) => {

            return <>
                <MDBDataTable responsive style={{ tfootDisplay: "none" }}
                    sortable={false}
                    searching={false}
                    displayEntries={false}
                    striped={false}
                    bordered={false}
                    hover
                    paging={false}
                    data={dataArray}
                    tag='applicant'
                    disableRetreatAfterSorting={true}
                />
            </>
        }
        const bookingData = {
            columns: [
                {
                    label: 'Application Ref. ID',
                    field: 'application_reference_code',
                    width: 150
                },

                {
                    label: 'Applicants',
                    field: 'applicants',
                    sort: 'asc',
                    width: 200
                },
                {
                    label: 'Country of Residence',
                    field: 'country_of_residence',
                    sort: 'asc',
                    width: 100
                },
                {
                    label: 'Nationality',
                    field: 'nationality',
                    sort: 'asc',
                    width: 150
                },
                {
                    label: 'Destination',
                    field: 'destination',
                    sort: 'asc',
                    width: 150
                },

                {
                    label: 'Application Status',
                    field: 'application_status',
                    sort: 'asc',
                    width: 150
                },
                {
                    label: 'Action',
                    field: 'action',
                    sort: 'asc',
                    width: 150
                },

            ],

            //  rows:this.state.applicationDataObj
            rows: this.state.applicationDataObj.map((i) => (
                {
                    application_reference_code: i.application_obj.application_reference_code,
                    applicants: i.application_obj.total_applicants,// this.showTotalApplicantCount(i.applicants_data),
                    country_of_residence: i.application_obj.origin,
                    nationality: i.application_obj.nationality,
                    destination: i.application_obj.travelling_to_country,
                    application_status: this.myApplication_BookingStatus(i.application_obj.application_state, i.application_obj),
                    action: this.myApplication_Actions(i.application_obj.application_state,
                        i.application_obj._id,
                        i.application_obj.travelling_to_identity,
                        i,
                        i.application_obj.base_currency_symbol),
                }
            ))
        }
        const applicantData = {
            columns: [
                {
                    label: 'Applicant Name',
                    field: 'applicant_name',
                    width: 150
                },

                {
                    label: 'Status',
                    field: 'status',
                    sort: 'asc',
                    width: 200
                },

                {
                    label: 'Action',
                    field: 'action',
                    sort: 'asc',
                    width: 150
                },

            ],

            rows: this.state.selectedApplicantData.map((i) => (
                {
                    applicant_name: (i.visa_form.first_name == null ? "" : i.visa_form.first_name) + " " + (i.visa_form.last_name == null ? "" : i.visa_form.last_name),
                    status: this.showVisaStatus(i.visa_status),// this.showTotalApplicantCount(i.applicants_data),
                    action: this.showVisaActionButton(i.visa_status, i._id, i.application_id, i)
                }
            ))
        }

        const showNormalTable = () => {
            if (this.state.paginatedItems.length === 0) {
                return <>
                    {this.showNoDataCard()}
                </>
            } else {
                return <>
                    <div class="table-responsive-md">
                        <table className="table ">
                            <tbody>
                                <tr >{renderMyApplicationTableHeader()}</tr>
                                {renderMyAppTableData()}
                            </tbody>
                        </table>
                    </div>
                </>
            }

        }

        const renderMyApplicationTableHeader = () => {

            return <>
                <th style={{ fontWeight: 'bold' }} scope="col">Ref. ID </th>
                <th style={{ fontWeight: 'bold' }} scope="col">Applicants </th>
                <th style={{ fontWeight: 'bold' }} scope="col">COR </th>
                <th style={{ fontWeight: 'bold' }} scope="col">Nationality </th>
                <th style={{ fontWeight: 'bold' }} scope="col">Destination</th>
                <th style={{ fontWeight: 'bold' }} scope="col">Date of Creation</th>
                {/* <th style={{fontWeight :'bold'}}scope="col">Reviewed By</th> */}
                <th style={{ fontWeight: 'bold' }} scope="col">Arrival Date</th>
                <th style={{ fontWeight: 'bold' }} scope="col">Departure Date</th>
                <th style={{ fontWeight: 'bold' }} scope="col">Application Status</th>
                <th style={{ fontWeight: 'bold' }} scope="col">Action </th>
            </>

        }
        const renderMyAppTableData = () => {
            return this.state.paginatedItems.map((i, index) => {
                //    const { id, name, age, email,applicant } = i //destructuring
                var class_name = "bg-white"
                if (index % 2 === 0) {
                    class_name = "bg-light"
                } else {
                    class_name = "bg-white"
                }
                const {
                    application_reference_code = i.application_obj.application_reference_code,
                    applicants = i.application_obj.total_applicants,// this.showTotalApplicantCount(i.applicants_data),
                    country_of_residence = i.application_obj.origin,
                    nationality = i.application_obj.nationality,
                    destination = i.application_obj.travelling_to_country,
                    created_on = this.getReadableDate(i.application_obj.created_on),
                    reviewed_by = "",
                    arrival_date = this.getReadableDate(i.application_obj.journey_start_date),
                    departure_date = this.getReadableDate(i.application_obj.journey_end_date),
                    application_status = this.myApplication_BookingStatus(i.application_obj.application_state, i.application_obj),
                    action = this.myApplication_Actions(i.application_obj.application_state,
                        i.application_obj._id,
                        i.application_obj.travelling_to_identity,
                        i,
                        i.application_obj.base_currency_symbol),
                    applicantData = i.applicants_data
                } = i

                var deleteAction = this.showDeleteAction(i.application_obj)

                return <>
                    <tr className={class_name} >
                        <td style={{ borderLeft: "1px solid #dee2e6", color: '#000000' }}>{application_reference_code}</td>
                        <td className={styles.applicationTextColor}>{applicants}</td>
                        <td className={styles.applicationTextColor}>{country_of_residence}</td>
                        <td className={styles.applicationTextColor}>{nationality}</td>
                        <td className={styles.applicationTextColor}>{destination}</td>
                        <td className={styles.applicationTextColor}>{created_on}</td>
                        {/* <td>{reviewed_by}</td> */}
                        <td className={styles.applicationTextColor}>{arrival_date}</td>
                        <td className={styles.applicationTextColor}>{departure_date}</td>
                        <td>{application_status}</td>
                        <td style={{ borderRight: "1px solid #dee2e6" }}>{action} {deleteAction}</td>
                    </tr>
                    <tr >
                        <td colspan="11" class="p-0">{ApplicantTable(applicantData, class_name)}</td>
                    </tr>

                    {/* {renderApplicantTableHeader()}</tr>
                {renderApplicantTableData(applicantData)}  */}

                </>
            })
        }
        const ApplicantTable = (applicantData, class_name) => {
            return <>
                <table className="table table-bordered " style={{ textIndent: "50px", overflowX: "auto" }}>
                    <tbody >
                        {/* <tr className={class_name}>{renderApplicantTableHeader()}</tr> */}
                        {renderApplicantTableData(applicantData, class_name)}
                    </tbody>
                </table>
            </>
        }
        const renderApplicantTableHeader = () => {

            return <>
                <th scope="col">Name of Applicant</th>
                <th scope="col">Passport Number </th>
                <th scope="col">Status</th>
                {/* <th scope="col"></th> */}
            </>
        }
        const renderApplicantTableData = (applicants, class_namee) => {
            return applicants.map((applicant, index) => {
                var class_name = "bg-white"
                if (index % 2 === 0) {
                    class_name = "bg-light"
                } else {
                    class_name = "bg-white"
                }
                var status = (applicant.visa_status == null ? "-" : applicant.visa_status)
                var visa_status = status
                if (visa_status === "pending") {
                    visa_status = "Decision Pending"
                } else if (visa_status === "decision_taken") {
                    visa_status = "Decision Taken"
                } else if (visa_status === "visa_in_process") {
                    visa_status = "Application In Progress"
                } else if (visa_status === "in_queue") {
                    visa_status = "In Queue"
                } else if (visa_status === "application_posted") {
                    visa_status = "Application Posted"
                } else if (visa_status === "application_approved") {
                    visa_status = "Approved"
                } else if (visa_status === "application_rejected") {
                    visa_status = "Not Approved"
                } else if (visa_status === "additional_documents_required") {
                    visa_status = "Additional Documents Required"
                } else {
                    visa_status = "-"
                }
                const { applicant_name = (applicant.visa_form.first_name == null ? "" : applicant.visa_form.first_name) + " " + (applicant.visa_form.last_name == null ? "" : applicant.visa_form.last_name),
                    passport = (applicant.visa_form.passport_number == null ? "" : applicant.visa_form.passport_number),
                    center = visa_status,//this.showVisaStatus(visa_status),
                    //  actions = this.showVisaActionButton(visa_status,applicant._id,applicant.application_id,applicant)
                } = applicant //destructuring
                return (
                    <tr className={class_namee} style={{ lineHeight: "5px" }}>
                        <td className={styles.applicantTd}  >{applicant_name}</td>
                        <td className={styles.applicantTd} >{passport}</td>
                        <td className={styles.applicantTd} >{center} &emsp; {this.showVisaActionButton(status, applicant._id, applicant.application_id, applicant)}</td>
                        {/* <td style={{width: "250px"}}>{actions}</td> */}
                    </tr>
                )
            })
        }
        const dateFormat = 'DD/MM/YYYY';
        const disabledDate = (current) => {
            // Can not select days before today and today
            return current && current < moment().endOf('day');
        }
        return (
            <>
                <h4><b>Track Application</b></h4>

                <MDBCard className="mb-4">
                    <MDBCardBody>
                        <MDBRow>
                            <MDBCol size="12" md="6" sm="6"></MDBCol>
                            <MDBCol size="12" md="6" sm="6" className="text-right">
                                <Space direction="vertical" size={12}>
                                    <RangePicker
                                        defaultValue={[moment(this.state.startDate), moment(this.state.endDate)]}
                                        format={dateFormat}
                                        onChange={this.handleDateRangeChange}
                                        allowClear={false}
                                    //disabledDate={disabledDate}
                                    //disablePast
                                    />
                                    {/* <DatePicker defaultValue={moment('2015/01/01', dateFormat)} format={customFormat} /> */}
                                </Space>
                            </MDBCol>
                        </MDBRow>
                        <div className=" mt-4">
                            {/* {showTable(bookingData)} */}
                            {showNormalTable()}
                        </div>
                    </MDBCardBody>
                </MDBCard>


                <div className="modal fade" id="DecisionModal" tabindex="-1" role="dialog" aria-labelledby="activityModalLabel" aria-hidden="true" isOpen={this.state.modal} toggle={() => this.toggleModal()} >
                    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <div>
                                    <h3 className="modal-title" id="activityModalLabel"><b>Visa Details</b></h3>
                                </div>

                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div style={{ marginTop: '5px', fontSize: 'calc(6px + .5rem)' }}><b>Ref ID: {this.state.selectedApplicationData.application_reference_code}</b></div>
                                <div style={{ marginTop: '5px', fontSize: 'calc(6px + .5rem)' }}>{this.state.selectedApplicationData.application_title} | {this.state.selectedApplicationData.total_days} {this.getDurationType(this.state.selectedApplicationData.duration_type)} | {this.state.selectedApplicationData.visa_processing_type} Visa | {this.state.selectedApplicationData.visa_entry_type} Entry  </div>
                                <div style={{ marginTop: '5px', fontSize: 'calc(6px + .5rem)' }}>{this.getReadableDate(this.state.selectedApplicationData.journey_start_date)} To {this.getReadableDate(this.state.selectedApplicationData.journey_end_date)} </div>
                                <div style={{ marginTop: '5px', fontSize: 'calc(6px + .5rem)' }}>{this.state.selectedApplicationData.total_applicants} Applicants</div>
                                <div></div>
                                {/* <div style={{marginTop:'5px',fontSize: 'calc(6px + .5rem)'}}>Submitted to Embassy : {this.state.embassySubmitDate}</div> */}
                                {/* <div style={{marginTop:'5px',fontSize: 'calc(6px + .5rem)'}}>Your application has been submitted to Embassy</div> */}

                                <div><hr /></div>
                                <div><h5> Applicants</h5></div>
                                <div>
                                    {showApplicantTable(applicantData)}
                                </div>

                            </div>
                            <div className="modal-footer">
                                <MDBBtn color="none" data-dismiss="modal" style={{ color: 'white', backgroundColor: 'black', textTransform: 'none', }}>Close</MDBBtn>
                            </div>
                            {/* <div className="modal-footer">
                                <MDBBtn color="none" data-dismiss="modal" style={{color:'white',backgroundColor:'black', textTransform:'none',}}>Cancel</MDBBtn>
                                <MDBBtn color="none" data-dismiss="modal" onClick={()=>{this.setState({toTrackApplication:true})}} style={{color:'white',backgroundColor:'#673784', textTransform:'none',}}>Schedule</MDBBtn>
                            </div> */}
                        </div>
                    </div>
                </div>
                {this.state.showBankTransferModel &&
                    <MDBModal centered isOpen={this.state.showBankTransferModel} toggle={this.hideBankTransferModel}  >
                        <MDBModalHeader toggle={this.hideBankTransferModel}>Submit Transaction Number</MDBModalHeader>
                        <MDBModalBody>
                            <MDBRow>
                                <MDBCol>
                                    <TextField
                                        style={{ width: '95%' }}
                                        error={this.state.isRecieptError}
                                        //id="standard-error-helper-text"
                                        label="Transaction Id"
                                        defaultValue=""
                                        value={this.state.reciept_number}
                                        onChange={this.handleRecieptChange}
                                        helperText={this.state.recieptErrormsg}
                                    />
                                </MDBCol>
                            </MDBRow>
                            <MDBRow className="mt-4">
                                <MDBCol>
                                    <h6 style={{ color: 'gray' }}>Transaction Date  </h6>
                                    <div><DateTimePicker
                                        onChange={this.handleBankDate}
                                        // onCalendarClose={this.handleBankDate}
                                        value={this.state.bank_trnsaction_date}
                                        disableClock
                                        format="dd/MM/yyyy"
                                        dayPlaceholder="dd"
                                        monthPlaceholder="mm"
                                        yearPlaceholder="yyyy"
                                        maxDate={new Date()}
                                        // clearIcon ='null'
                                        style={{ width: '100%', marginTop: '20px', borderWidth: 0, border: 0 }}
                                    />
                                    </div>{
                                        this.state.isDateError &&
                                        <small style={{ color: 'red' }}>Please select transaction date</small>
                                    }

                                    {/* <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                        <KeyboardDatePicker
                                        style={{zIndex:'2000'}}
                                            disableToolbar
                                            variant="inline"
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id="transaction_date"
                                            label="Transaction Date"
                                            value={this.state.bank_trnsaction_date}
                                            onChange={this.handleBankDate}
                                            autoOk
                                    
                                            InputLabelProps={{
                                                shrink: true,
                                              }}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            
                                        />
                                        </MuiPickersUtilsProvider> */}
                                </MDBCol>
                            </MDBRow>
                            <MDBRow className="mt-4"></MDBRow>
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color='white' style={{ textTransform: 'none' }} onClick={this.hideBankTransferModel} >Cancel</MDBBtn>
                            <MDBBtn color="dark" style={{ textTransform: 'none' }} onClick={() => this.handleBankConfirmClick()}>Confirm</MDBBtn>
                        </MDBModalFooter>
                    </MDBModal>
                }

                {this.state.showActivityModal &&
                    <MDBModal centered isOpen={this.state.showActivityModal} toggle={this.hideActivityModal}  >
                        <MDBModalHeader toggle={this.hideActivityModal}>Application Activity</MDBModalHeader>
                        <MDBModalBody>
                            <MDBRow>
                                <MDBCol>
                                    <Stepper step orientation="vertical"  >
                                        {this.state.activity.map((act) => (


                                            <Step active>
                                                <StepLabel StepIconComponent={stepsIcon}>
                                                    <p className="m-1"> {act.activity} </p>
                                                </StepLabel>
                                                <StepContent>
                                                    <small> {new Date(act.activity_on).toDateString()} {new Date(act.activity_on).toTimeString()} </small>
                                                </StepContent>
                                            </Step>

                                        ))}
                                    </Stepper>
                                </MDBCol>
                            </MDBRow>
                        </MDBModalBody>

                    </MDBModal>
                }
                {this.state.ShowArchiveModal &&
                    <MDBModal centered isOpen={this.state.ShowArchiveModal} toggle={this.hideArchiveModal}>
                        <MDBModalHeader toggle={this.hideArchiveModal}>Delete Confirmation</MDBModalHeader>
                        <MDBModalBody>
                            <MDBRow>
                                <MDBCol >
                                    Are you sure you want to delete this application?
                                           </MDBCol>
                            </MDBRow>

                            <MDBRow className="mt-4"></MDBRow>
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color='white' style={{ textTransform: 'none' }} onClick={this.hideArchiveModal} >Cancel</MDBBtn>
                            <MDBBtn color="dark" style={{ textTransform: 'none' }} onClick={() => this.handleArchiveConfirmClick()}>Delete</MDBBtn>
                        </MDBModalFooter>
                    </MDBModal>
                }
                {
                    this.state.applicationDataObj.length > 10 &&

                    <MDBRow id="footerRow" style={{ width: "100%" }}>
                        <MDBFooter style={{ background: "#fff", position: "fixed", bottom: "0px", width: "100%", right: "0", borderTop: "1px solid #ccc", boxShadow: "0px 0 10px rgba(0, 0, 0, 0.2)", zIndex: "-1" }} color="white" className="pb-1 pt-1 text-right">

                            <MDBRow>
                                <MDBCol>
                                    <MDBPagination style={{ zIndex: "0" }} className=" float-right  bottom-0 right-0">
                                        <MDBPageItem>
                                            <MDBPageNav aria-label="Previous">
                                                <span aria-hidden="true" style={{ fontWeight: (this.state.pageNo === 1 ? "" : "bold"), cursor: (this.state.pageNo === 1 ? "auto" : "pointer"), color: localStorage.getItem("brand_color") }} onClick={this.previousPage}>Previous</span>
                                            </MDBPageNav>
                                        </MDBPageItem>
                                        <MDBPageItem>
                                            <MDBPageNav  >
                                                <span style={{ backgroundColor: "#2e3192", }} className="p-2 text-white pl-3 pr-3 ">{this.state.pageNo === "" ? 1 : this.state.pageNo}</span>

                                            </MDBPageNav>
                                        </MDBPageItem>

                                        <MDBPageItem>
                                            <MDBPageNav aria-label="Previous">
                                                <span aria-hidden="true" onClick={this.nextPage} style={{ fontWeight: (this.state.pageNo === this.state.totalPages ? "" : "bold"), cursor: (this.state.pageNo === this.state.totalPages ? "auto" : "pointer"), color: localStorage.getItem("brand_color") }}>Next</span>
                                            </MDBPageNav>
                                        </MDBPageItem>
                                    </MDBPagination>
                                </MDBCol>
                            </MDBRow>
                        </MDBFooter>
                    </MDBRow>
                }
            </>
        )
    }
}

export default TrackApplication
